export default routesConfig;

/** @ngInject */
function routesConfig($urlRouterProvider, $locationProvider, $stateProvider) {
  $locationProvider.html5Mode(true).hashPrefix('!');

  $stateProvider
    .state('app', {
      abstract: true,
      resolve: {
        user: SchoolCommonRoomService => SchoolCommonRoomService.getUser(),
        currentSchoolCommonRoom: SchoolCommonRoomService => SchoolCommonRoomService.getCurrentSchoolCommonRoom(),
        me: SchoolCommonRoomService => SchoolCommonRoomService.getMe()
      },
      onEnter: (
        $log, $state, $location,
        user,
        currentSchoolCommonRoom,
        me,
        SchoolCommonRoomService,
        AccessService
      ) => {
        if (user.isAdmin) {
          return $state.target('configuration.schoolCommonRooms');
        }

        if (!currentSchoolCommonRoom) {
          return $state.target('schoolCommonRoom.select');
        }

        if (!me) {
          return SchoolCommonRoomService.getMe(true);
        }

        if (me) {
          if (me.roleName === 'MANAGER') {
            return AccessService.getAll(currentSchoolCommonRoom.id, true);
          }
        }
      }
    });

  $urlRouterProvider.otherwise('/dashboard');
}
